import { Button } from "@components/Button"
import { useNavigate } from "react-router-dom"

const AdsSummary = () => {
  const navigate = useNavigate()
  return (
    <div className="flex justify-center items-center min-h-[calc(100vh-64px)] p-8">
      <div className="max-w-[600px] w-full text-center p-8 bg-white rounded-lg shadow-lg">
        <h1 className="text-4xl mb-4 text-gray-800">Ad posting complete</h1>
        <p className="text-gray-600 mb-8">
          Your ad posting has been processed.
        </p>
        <div className="flex justify-center mt-8">
          <Button
            variant="primary"
            size="lg"
            text="Back to home"
            className=" bg-indigo-600 hover:bg-indigo-700 text-white"
            onClick={() => navigate("/")
            }
          />
        </div>
      </div>
    </div>
  )
}

export default AdsSummary
